import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { VBTogglePlugin } from 'bootstrap-vue'
Vue.use(VBTogglePlugin)
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
